import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";

const VendorEdit = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ vendorType, setVendorType ] = useState([])
  const [ vendoroptions, setVendorOptions ] = useState([])
  const [ PaymentTermOptions, setPaymentTermOptions ] = useState([])
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const navigate = useNavigate()
  const Token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

useEffect(() => {
  userTypedropdown()
},[])

const userTypedropdown = async () => {
  try{
    const response = await axiosInstance.get("/bp-onboard/bplist",{
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    })

    const data = response.data.data.data
    const userTypeOptions = data.map(user => ({
      value: user.onboard_id,
      label:user.bp_name,
    }))

    setUserTypedd(userTypeOptions)
    vendortypeoptions()
  }catch(error) {
    console.log(error)
  }
}

const vendortypeoptions = async () => {
  try{
    const response = await axiosInstance.post("/vendortype/ddlvendortype",{
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    })

    const data = response.data.data.data
    const vendoroptions = data.map(user => ({
      value: user.ID,
      label:user.NAME,
    }))
    setVendorOptions(vendoroptions)
    const PaymentTermresponse = await axiosInstance.post("/paymentterm/ddlpaymentterm",{
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    })

    const Paymentdata = PaymentTermresponse.data.data.data
    const paymentoptions = Paymentdata.map(user => ({
      value: user.ID,
      label:user.NAME,
    }))
    console.log("paymentoptions",paymentoptions);
    
    setPaymentTermOptions(paymentoptions)
  }catch(error) {
    console.log(error)
  }
}

const fetchVendorType = async () => {
  try{
    const response = await axiosInstance.get(`/vendor/edit/${data.vendor_onboard_id}`,{
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
      },
  })
  const fetchedData = response.data.data
  
     console.log("fetchedData>>",fetchedData);
     
  const formatedDATA = {
    business_partner_id:fetchedData?.business_partner_id,
    vendortype: fetchedData.vendor_type_id,
    companyname:fetchedData?.companyname,
    contact_no:fetchedData?.contactno,
    email_id:fetchedData?.email_id,
    pincode:fetchedData?.pincode,
    // country: fetchedData.country_name,
    // state: fetchedData.state_name,
    // city: fetchedData.city_name,
    address:fetchedData?.address,
    state_id: fetchedData.state_id,
    city_id: fetchedData.city_id,
    country_id: fetchedData.country_id,
    address:fetchedData?.address,
    paymentterms:fetchedData?.paymentterm_id,
    bankname:fetchedData?.bankname,
    ifsc:fetchedData?.ifsc,
    accountno:fetchedData?.accountno,
    panno:fetchedData?.panno,
    gstno:fetchedData?.gstno,
    tin:fetchedData?.tinno,
    adhaar:fetchedData?.aadharno,
    status: fetchedData.status
  }
  console.log("fomatteddata",formatedDATA);
  
  setFormData(formatedDATA)
  setVendorType(fetchedData)
  console.log(formData, "HSNCODE DATA")

}catch(error){
    console.log(error)
  }

}

useEffect(() => {
  fetchVendorType();
},[])

const handleFormSubmit = async (formData) => {
  console.log("formDataVendor>>>", formData);

  const errors = {};
  let isValid = true;
  VendorTYpeInputs.forEach((field) => {
    if (field.validation && field.validation.required) {
      if (!formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
    }
  });

  if (!isValid) {
    setValidationErrors(errors);
    return;
  }
  
  const confirmation = await Swal.fire({
    title: "Update Vendor",
    text: "Do you want to update this vendor?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  });
  if (confirmation.isConfirmed) {
    try {
      setLoading(true);
      const payload = {
        vendor_type_id: formData.vendortype,
        companyname: formData.companyname,
        contactno: formData.contact_no,
        email_id: formData.email_id,
        pincode: formData.pincode,
        country_id: formData.country_id,
        state_id: formData.state_id,
        city_id: formData.city_id,
        address: formData.address,
        paymentterm_id: formData.paymentterms,
        bankname: formData.bankname,
        ifsc: formData.ifsc,
        accountno: formData.accountno,
        panno: formData.panno,
        gstno: formData.gstno,
        tinno: formData.tin,
        aadharno: formData.adhaar,
        status: formData.status === "Active" ? 1 : 0,
      };

      // Set business partner ID based on user type
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
      const response = await axiosInstance.patch(`/vendor/update/${data.vendor_onboard_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });

      console.log("Update successful:", response.data);

      await Swal.fire({
        title: "Success",
        text: "Vendor updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate(-1);
    } catch (error) {
      console.error("Error updating vendor:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      await Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  } else {
    setLoading(false);
  }
};

  

  const backNavigate = () => {
    navigate("/admin/manage-logistic/vendor-master")
}

const VendorTYpeInputs = [
  ...(userType === "superadmin"
    ? [
        {
          name: "business_partner_id",
          label: "Business Partner",
          type: "dropdown",
          required: true,
          options: userTypedd,
          gridClass: "col-lg-4",
         
        },
      ]
    : []),
    {
      name: "vendortype",
      label: "Vendor Type",
      placeholder:"Enter VendorType Name",
      type: "dropdown",
      options:vendoroptions,
      required: true,
      validation: { required: true,
      
       },
      gridClass: "col-lg-4",
    },
  {
    name: "companyname",
    label: "Vendor Name",
    placeholder:"Enter Vendor Name",
    type: "text",
    required: true,
    validation: { required: true,
      pattern: /^[A-Za-z0-9-\s]*$/,
      message: "Special symbols are not allowed",
     },
    gridClass: "col-lg-4",
  },
  {
    name: "contact_no",
    label: "Contact No.",
    placeholder:"Enter Contact No.",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { 
      required: true, pattern: /^[6-9]/ ,
      minLength:10,
      maxLength:10,
      message1: "Contact no should start with 6, 7, 8, 9",
      message: "Please enter a valid 10-digit",
    }
  },
  {
    name: "email_id",
    label: "Email Address",
    placeholder:"Enter Email Address",
    type: "email",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email Address"},
  },
  {
    name: "pincode",
    label: "Pin Code",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true, maxLength:6 },
  },
  {
    name: "country",
    label: "Country",
    type: "text",
    required: true,
    disabled:true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "state",
    label: "State",
    type: "text",
    required: true,
    disabled:true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: true,
    disabled:true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "address",
    label: "Address",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "panno",
    label: "PAN No.",
    type: "text",
    placeholder: "Enter PAN No.",
    validation: { 
      required: false, 
      // pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 
      // message: "Please enter a valid 10-character PAN number"
    },
    required: false,
    gridClass: "col-lg-4",
  },
  {
    name: "gstno",
    label: "GST No.",
    type: "text",
    placeholder: "Enter GST No.",
    validation: { 
      required: false, 
      pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 
      message: "Please enter a valid 15-character GST number",
      maxLength:15
    },
    required: false,
    gridClass: "col-lg-4",
  },
    {
      name: "adhaar",
      label: "Aadhaar No.",
      type: "text",
      placeholder:"Enter Aadhaar No.",
       validation: { 
      required: false, 
      pattern: /^\d{12}$/, 
      message: "Please enter a valid 12-digit Aadhar number",
      maxLength:12,
    },
      required: false,
     
      gridClass: "col-lg-4",
    },
    {
      name: "tin",
      label: "Tin No.",
      type: "text",
      placeholder:"Enter Tin No.",
       validation: { 
      required: false, 
      // pattern: /^\d{12}$/, 
      // message: "Please enter a valid 12-digit Aadhar number",
      // maxLength:12,
    },
      required: false,
     
      gridClass: "col-lg-4",
    },
  {
    name: "paymentterms",
    label: "Payment Term",
    type: "dropdown",
    required: true,
    options: PaymentTermOptions,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "bankname",
    label: "Bank Name",
    type: "text",
    placeholder:"Enter Bank Name",
    required: true,
    validation: { required: true,pattern: /^[a-zA-Z0-9 ]+$/, message: "Only Alphabets digits Are Allowed*", maxLength:25 },
    gridClass: "col-lg-4",
  },
  {
    name: "ifsc",
    label: "IFSC code",
    type: "text",
    placeholder:"Enter IFSC Code",
    required: true,
    validation: { required: true,pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: "Please Enter Valid IFSC Code*",maxLength:12 },
    gridClass: "col-lg-4",
  },
  {
    name: "accountno",
    label: "Account Number",
    type: "text",
    placeholder:"Enter Account Number",
    required: true,
    validation: { required: true,pattern: /^\d{9,18}$/, message: "Please Enter valid Account Number",maxLength:18 },
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "dropdown",
    required: true,
    options: [
      { id: 1, label: "Active", value: "Active" },
      { id: 0, label: "Inactive", value: "Inactive" },
    ],
    gridClass: "col-lg-4",
    validation: { required: true },
  },

  
];

  return (
    <>
    <div>
        {loading ? (
          <Loader/>
        ) : (
          <>
      <div className="backbutton mt-2 mb-2">
        <img onClick={backNavigate} src={backicon} alt="back" />
        <span className="backbtntitle">Update Vendor</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Update the Vendor Details
        </span>
        <DynamicForm
          formConfig={VendorTYpeInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
       
        
      </div>
    
      <div className="btncontainer mt-3">
      <button
  onClick={() => {
   
      handleFormSubmit(formData); 
   
       
    
  }}
  className="submit-btn"
>
  Submit
</button>

        </div></>
        )}
        </div>
    </>
  );
};

export default VendorEdit;
